// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__11HTG","footer":"ModalFilter_footer__23les"};